// core/constants/routes.ts

export const ROUTES = {
  // Públicas
  login: '/login',
  register: '/register',
  forgotPassword: '/forgot-password',
  verifyRecoveryCode: '/verify-recovery-code',
  resetPassword: '/reset-password',
  authCallback: '/auth/callback',

  // Sin organización requerida
  onboarding: '/onboarding',
  profileSetup: '/profile/setup',
  billing: '/billing',
  invitationsAccept: '/invitations/accept',

  // Protegidas con orgId
  tenantDashboard: (orgId: string) => `/${orgId}/dashboard`,
  projectDashboard: (orgId: string, projectId: string) =>
    `/${orgId}/projects/${projectId}/dashboard`,
  laborPerformance: (orgId: string) => `/${orgId}/labor-performance`,
  orgSummary: (orgId: string) => `/${orgId}/analytics`,
  members: (orgId: string) => `/${orgId}/members`,
  boards: (orgId: string, projectId: string) => `/${orgId}/projects/${projectId}/boards`,
  projectSettings: (orgId: string, projectId: string) => `/${orgId}/projects/${projectId}/settings`,
  formsList: (orgId: string) => `/${orgId}/forms`,
  formEditor: (orgId: string, formId: string) => `/${orgId}/forms/${formId}`,
  formRespond: (orgId: string, formId: string) => `/${orgId}/forms/${formId}/respond`,
  notesList: (orgId: string) => `/${orgId}/notes`,
  noteEditor: (orgId: string, noteId: string) => `/${orgId}/notes/${noteId}`,
  personalSummary: (orgId: string) => `/${orgId}/personal-summary`,
  timeOff: (orgId: string) => `/${orgId}/time-off`,
  timeOffRequest: (orgId: string, requestId: string) => `/${orgId}/time-off/requests/${requestId}`,
  calendar: (orgId: string) => `/${orgId}/calendars`,

  // Pública, sin organización activa
  publicFormSubmit: (formId: string) => `/f/${formId}`,
  publicFormAccessByToken: (token: string) => `/f/access/${token}`,
} as const;

// Rutas que no requieren organización activa
export const ROUTES_WITHOUT_ORG = [
  ROUTES.onboarding,
  ROUTES.profileSetup,
  ROUTES.billing,
  ROUTES.invitationsAccept,
] as const;

// Rutas públicas
export const PUBLIC_ROUTES = [
  ROUTES.login,
  ROUTES.register,
  ROUTES.forgotPassword,
  ROUTES.verifyRecoveryCode,
  ROUTES.resetPassword,
  ROUTES.authCallback,
] as const;
